(ns dashboard.components.combobox
  "A combobox, with an editable text field, and a dropdown for selection value"
  (:require ["react" :as react]
            [io.repliance.ui.util :refer [is-descendant-of?]]))

(defn select-option [on-set-value on-commit set-show-options value option]
  (when-not (= value option)
    (on-set-value option)
    (when on-commit
      (on-commit option))
    (set-show-options false)))

(defn combobox [{:keys [options value on-set-value on-commit validation-error editable? title up?]}]
  (let [[ref set-ref] (react/useState nil)
        [show-options set-show-options] (react/useState false)]
    (react/useEffect (fn []
                       (let [click-handler (fn [e]
                                             (when-not (is-descendant-of? (.-target e) ref)
                                               (set-show-options false)))]
                         (js/document.addEventListener "click" click-handler)
                         (fn []
                           (js/document.removeEventListener "click" click-handler))))
                     (array ref))
    [:div.field-body
     {:title title}
     [:div.field.has-addons
      [:div.control.is-expanded
       [:input.input
        {:disabled (not editable?)
         :class (when validation-error
                  "is-danger")
         :type "text"
         :value value
         :on-change (fn [e]
                      (on-set-value (.. e -target -value)))
         :on-key-down (fn [e]
                        (when (= "Enter" (.-key e))
                          (cond
                            on-commit
                            (on-commit value)

                            on-set-value
                            (on-set-value value))))}]
       (when validation-error
         [:p.help.is-danger validation-error])]
      (when editable?
        [:div.dropdown.is-right
         {:class (cond-> []
                   show-options
                   (conj "is-active")

                   up?
                   (conj "is-up"))
          :ref set-ref}
         [:div.dropdown-trigger
          [:button.button.is-tertiary
           {:aria-haspopup "true"
            :aria-controls "dropdown-menu"
            :on-click (fn [_]
                        (set-show-options (not show-options)))}
           [:span.icon.is-small>i.fas.fa-angle-down
            {:aria-hidden "true"}]]]
         [:div.dropdown-menu {:role "menu"}
          [:div.dropdown-content
           (for [option options]
             [:a.dropdown-item
              {:key option
               :tab-index 0
               :on-click (fn [_]
                           (select-option on-set-value on-commit set-show-options value option))
               :on-key-down (fn [e]
                              (let [key-down (.-key e)]
                                (when (#{" " "Enter"} key-down)
                                  (select-option on-set-value on-commit set-show-options value option))))}
              option])]]])]]))

